import { render, staticRenderFns } from "./CashRedEnvelopePopup.vue?vue&type=template&id=6fc25e54&scoped=true"
import script from "./CashRedEnvelopePopup.vue?vue&type=script&lang=js"
export * from "./CashRedEnvelopePopup.vue?vue&type=script&lang=js"
import style0 from "./CashRedEnvelopePopup.vue?vue&type=style&index=0&id=6fc25e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc25e54",
  null
  
)

export default component.exports